import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const STEEPING_DISPLAY_NAMES = [
    {
        referenceName: "wet_1st_hours",
        displayName: "1st wet",
    },
    {
        referenceName: "dry_1st_hours",
        displayName: "1st dry",
    },
    {
        referenceName: "wet_2nd_hours",
        displayName: "2nd wet",
    },
    {
        referenceName: "dry_2nd_hours",
        displayName: "2nd dry",
    },
];
const GERMINATION_DISPLAY_NAMES = [
    {
        referenceName: "day_1_temperature",
        displayName: "1st day/°C",
    },
    {
        referenceName: "day_1_temperature_factual_before",
        displayName: "1st day/°C before vessel",
    },
    {
        referenceName: "day_1_temperature_factual_after",
        displayName: "1st day/°C  after vessel",
    },
    {
        referenceName: "day_2_temperature",
        displayName: "2nd day/°C",
    },
    {
        referenceName: "day_2_temperature_factual_before",
        displayName: "2nd day/°C before vessel",
    },
    {
        referenceName: "day_2_temperature_factual_after",
        displayName: "2nd day/°C after vessel",
    },
    {
        referenceName: "day_3_temperature",
        displayName: "3rd day/°C",
    },
    {
        referenceName: "day_3_temperature_factual_before",
        displayName: "3rd day/°C before vessel",
    },
    {
        referenceName: "day_3_temperature_factual_after",
        displayName: "3rd day/°C after vessel",
    },
    {
        referenceName: "day_4_temperature",
        displayName: "4th day/°C",
    },
    {
        referenceName: "day_5_temperature",
        displayName: "5th day/°C",
    },
    {
        referenceName: "dq_total",
        displayName: "dq total",
    },
    {
        referenceName: "co2_total",
        displayName: "CO2 total",
    },
];

function ResultsTable(props: any) {

    const germination1 = props.results.freestyleJson.recommended_recipes_germination_1;
    const germination5 = props.results.freestyleJson.recommended_recipes_germination_5;
    const steeping1 = props.results.freestyleJson.recommended_recipes_steeping_1;
    const steeping5 = props.results.freestyleJson.recommended_recipes_steeping_5;

    const filteredGermination1 = germination1.filter((element: any) => element.referenceName !== "used_batch_string");
    const filteredGermination5 = germination5.filter((element: any) => element.referenceName !== "used_batch_string");
    const filteredSteeping1 = steeping1.filter((element: any) => element.referenceName !== "used_batch_string");
    const filteredSteeping5 = steeping5.filter((element: any) => element.referenceName !== "used_batch_string");

    const cleanedGerminationValues1 = filteredGermination1.map((element: any) => ({ ...element, value: Math.round(element.value * 100) / 100 }));
    const cleanedGerminationValues5 = filteredGermination5.map((element: any) => ({ ...element, value: Math.round(element.value * 100) / 100 }));

    const steepingCombined = filteredSteeping1.map((element: any, index: number) => {
        const combinedElement = structuredClone(element);
        combinedElement["recommended_recipes_steeping_1"] = element["value"];
        combinedElement["recommended_recipes_steeping_5"] = filteredSteeping5[index]["value"];
        delete combinedElement["value"];
        delete combinedElement["type"];
        return combinedElement;
    });

    for (let i = 0; i < steepingCombined.length; i++) {
        for (let j = 0; j < STEEPING_DISPLAY_NAMES.length; j++) {
            if (steepingCombined[i].referenceName === STEEPING_DISPLAY_NAMES[j].referenceName) {
                steepingCombined[i]["displayName"] = STEEPING_DISPLAY_NAMES[j]["displayName"];
            }
        }
    }

    const germinationCombined = cleanedGerminationValues1.map((element: any, index: number) => {
        const combinedElement = structuredClone(element);
        combinedElement["recommended_recipes_germination_1"] = element["value"];
        combinedElement["recommended_recipes_germination_5"] = cleanedGerminationValues5[index]["value"];
        delete combinedElement["value"];
        delete combinedElement["type"];
        return combinedElement;
    });

    for (let i = 0; i < germinationCombined.length; i++) {
        for (let j = 0; j < GERMINATION_DISPLAY_NAMES.length; j++) {
            if (germinationCombined[i].referenceName === GERMINATION_DISPLAY_NAMES[j].referenceName) {
                germinationCombined[i]["displayName"] = GERMINATION_DISPLAY_NAMES[j]["displayName"];
            }
        }
    }

    const steepingTransposed: any[] = [];
    for (let i = 0; i < steepingCombined.length; i++) {
        const displayName = steepingCombined[i]["displayName"];
        const top1 = steepingCombined[i].recommended_recipes_steeping_1;
        const top5 = steepingCombined[i].recommended_recipes_steeping_5;

        steepingTransposed[0] = { ...steepingTransposed[0], [displayName]: top1 };
        steepingTransposed[0] = { ...steepingTransposed[0], top: "Top 1" };
        steepingTransposed[1] = { ...steepingTransposed[1], [displayName]: top5 };
        steepingTransposed[1] = { ...steepingTransposed[1], top: "Top 5 (average)" };
    }

    const germinationTransposed: any[] = [];
    for (let i = 0; i < germinationCombined.length; i++) {
        const displayName = germinationCombined[i]["displayName"];
        const top1 = germinationCombined[i].recommended_recipes_germination_1;
        const top5 = germinationCombined[i].recommended_recipes_germination_5;

        germinationTransposed[0] = { ...germinationTransposed[0], [displayName]: top1 };
        germinationTransposed[0] = { ...germinationTransposed[0], top: "Top 1" };
        germinationTransposed[1] = { ...germinationTransposed[1], [displayName]: top5 };
        germinationTransposed[1] = { ...germinationTransposed[1], top: "Top 5 (average)" };
    }

    const bestBatches = props.results.freestyleJson.best_batches[0];

    return (
        <div className="flex flex-wrap gap-5">
            <DataTable value={bestBatches} header="Best Batches" tableStyle={{ width: "200px" }}>
                <Column field="batch_year" alignHeader="center" header="Year" style={{ width: "50%", textAlign: "center" }} />
                <Column field="batch_nr" alignHeader="center" header="Number" style={{ width: "50%", textAlign: "center" }} />
            </DataTable>
            <DataTable value={steepingTransposed} header="Steeping Recommendations" tableStyle={{ width: "400px" }}>
                <Column field="top" alignHeader="center" header="" style={{ width: "20%", textAlign: "center" }} />
                <Column field="1st wet" alignHeader="center" header="1st wet" style={{ width: "20%", textAlign: "center" }} />
                <Column field="1st dry" alignHeader="center" header="1st dry" style={{ width: "20%", textAlign: "center" }} />
                <Column field="2nd wet" alignHeader="center" header="2nd wet" style={{ width: "20%", textAlign: "center" }} />
                <Column field="2nd dry" alignHeader="center" header="2nd dry" style={{ width: "20%", textAlign: "center" }} />
            </DataTable>
            <DataTable value={germinationTransposed} header="Germination Recommendations" tableStyle={{ width: "100%" }}>
                <Column field="top" alignHeader="center" header="" style={{ width: "8%", textAlign: "center" }} />
                <Column field="1st day/°C" alignHeader="center" header="1st day/°C" style={{ width: "8%", textAlign: "center" }} />
                <Column field="2nd day/°C" alignHeader="center" header="2nd day/°C" style={{ width: "8%", textAlign: "center" }} />
                <Column field="3rd day/°C" alignHeader="center" header="3rd day/°C" style={{ width: "8%", textAlign: "center" }} />
                <Column field="4th day/°C" alignHeader="center" header="4th day/°C" style={{ width: "8%", textAlign: "center" }} />
                <Column field="5th day/°C" alignHeader="center" header="5th day/°C" style={{ width: "8%", textAlign: "center" }} />
                <Column field="dq total" alignHeader="center" header="dq total" style={{ width: "8%", textAlign: "center" }} />
                <Column field="CO2 total" alignHeader="center" header="CO2 total" style={{ width: "8%", textAlign: "center" }} />
                <Column field="1st day/°C before vessel" alignHeader="center" header="1st day/°C before vessel" style={{ width: "8%", textAlign: "center" }} />
                <Column field="1st day/°C  after vessel" alignHeader="center" header="1st day/°C after vessel" style={{ width: "8%", textAlign: "center" }} />
                <Column field="2nd day/°C before vessel" alignHeader="center" header="2nd day/°C before vessel" style={{ width: "8%", textAlign: "center" }} />
                <Column field="2nd day/°C after vessel" alignHeader="center" header="2nd day/°C after vessel" style={{ width: "8%", textAlign: "center" }} />
                <Column field="3rd day/°C before vessel" alignHeader="center" header="3rd day/°C before vessel" style={{ width: "8%", textAlign: "center" }} />
                <Column field="3rd day/°C after vessel" alignHeader="center" header="3rd day/°C after vessel" style={{ width: "8%", textAlign: "center" }} />
            </DataTable>
        </div>
    );
}

export default ResultsTable;
